<template>
    <div class="col-auto burger-menu d-flex align-items-center">
        <hb-dropdown
            ref="themesPlayerDropdown"
            class="themes-player-dropdown"
            :is-icon="false"
            :align="'bottom'"
        >
            <template slot="btn">
                <svg
                    class="themes-menu"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                >
                    <path
                        fill="#FFFFFF"
                        fill-rule="nonzero"
                        d="M4.609 17.597a1.017 1.017 0 0 1 0-2.033h.65c.556 0 1.016.46 1.016 1.02a1.02 1.02 0 0 1-1.016 1.013h-.65zm4.43 0a1.017 1.017 0 0 1 0-2.033h10.345c.56 0 1.02.459 1.02 1.02 0 .56-.46 1.013-1.02 1.013H9.039zm-4.43-9.17a1.017 1.017 0 0 1-1.013-1.012c0-.56.457-1.012 1.013-1.012h.65c.555 0 1.016.453 1.016 1.012A1.02 1.02 0 0 1 5.26 8.427h-.65zm4.43 0a1.017 1.017 0 0 1-1.012-1.012c0-.56.456-1.012 1.012-1.012h10.345c.56 0 1.02.451 1.02 1.012 0 .558-.46 1.012-1.02 1.012H9.039zm-4.43 4.585a1.02 1.02 0 0 1-1.013-1.017c0-.558.458-1.015 1.013-1.015h.65c.555 0 1.016.457 1.016 1.015 0 .556-.462 1.017-1.016 1.017h-.65zm4.43 0a1.02 1.02 0 0 1-1.012-1.017c0-.559.456-1.015 1.012-1.015h10.345c.56 0 1.02.455 1.02 1.015 0 .558-.46 1.017-1.02 1.017H9.039z"
                    />
                </svg>
                <img
                    class="themes-close"
                    src="@assets/img/x-gray.svg"
                    alt="X"
                    width="20px"
                >
            </template>
            <template slot="body">
                <ul class="row">
                    <li v-for="(theme, index) in audioSources" :key="index" class="col-12 col-lg text-truncate">
                        <a href="" @click.prevent="changeSelectedAudio(index)">
                            <theme-pill :theme="theme">
                                <template #icon>
                                    <svg
                                        v-show="index == selectedAudioSource && isPlaying"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            fill="#FFFFFF"
                                            fill-rule="evenodd"
                                            d="M17.137 18.342V5.658A.671.671 0 0 0 16.453 5h-2.267a.671.671 0 0 0-.683.658v12.684c0 .363.306.658.683.658h2.267a.671.671 0 0 0 .684-.658M9.95 19H7.683A.67.67 0 0 1 7 18.342V5.658A.67.67 0 0 1 7.683 5h2.268c.377 0 .683.294.683.658v12.684a.671.671 0 0 1-.683.658"
                                        />
                                    </svg>
                                    <svg
                                        v-show="!(index == selectedAudioSource) || (index == selectedAudioSource && !isPlaying)"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            fill="#FFFFFF"
                                            fill-rule="nonzero"
                                            d="M17.828 11.185l-7.507-5.938c-.344-.258-.787-.329-1.181-.14-.394.163-.64.539-.64.961v11.876c0 .422.246.798.64.962.148.07.32.094.468.094.246 0 .516-.094.713-.235l7.507-5.937c.247-.212.394-.493.394-.822 0-.305-.147-.61-.394-.821z"
                                        />
                                    </svg>
                                </template>
                            </theme-pill>
                        </a>
                    </li>
                </ul>
            </template>
        </hb-dropdown>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import playerEventsMixins from "./playerEventsMixins";
import freemiumAccessMixins from "@/mixins/freemiumAccessMixins";

export default {
    name: "AudioPlayerMenu",
    components: {
        themePill: () => import(/* webpackChunkName: "theme-pill"*/ "@c/reader-mode/theme/theme-pill")
    },
    mixins: [playerEventsMixins, freemiumAccessMixins],
    props: {
        isMainPlayer: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapState({
            bookInsight: state => state.NonfictionPlayer.bookInsight,
            audioSources: state => state.NonfictionPlayer.audioSources,
            readerThemes: state => state.NonfictionReader.readerThemes,
            selectedAudioSource: state => state.NonfictionPlayer.selectedAudioSource,
            showReaderMode: state => state.NonfictionReader.showReaderMode,
            isPlaying: state => state.NonfictionPlayer.isPlaying,
            elapsedDuration: state => state.NonfictionPlayer.elapsedDuration
        }),
        ...mapGetters({
            currentAudioSource: "NonfictionPlayer/currentAudioSource",
            isLoggedIn: "User/isLoggedIn"
        })
    },
    created() {
        if (this.isMainPlayer) {
            this.$watch("currentAudioSource.progress", async() => {
                if (!this.isPlaying) {
                    return;
                }

                this.$_dispatchPlayerActionEvent("progress", this.actionEventProps);
            });
        }
    },
    methods: {
        changeSelectedAudio(index = 0) {
            if (index >= this.freemiumThemesAvailable && this.$_freemiumBiLocked()) {
                this.$_scrollToSignUpWall({ behavior: "smooth", block: "nearest" });
                return;
            }

            if (index == this.selectedAudioSource) {
                this.$store.dispatch("NonfictionPlayer/toggle");
                const currentPlayingState = this.isPlaying ? "play" : "pause";
                this.$_dispatchPlayerActionEvent(currentPlayingState, this.actionEventProps);
            } else {
                this.$_dispatchPlayerActionEvent("pause", this.actionEventProps);
                const readerThemeIndex = this.getThemeIndexById(this.audioSources[index].id);
                this.$store.dispatch("NonfictionPlayer/setSelectedAudioSource", index);

                if (this.showReaderMode && readerThemeIndex >= 0) {
                    this.$store.dispatch("NonfictionReader/setSelectedReaderTheme", readerThemeIndex);
                    const themeToFocus = document.getElementById(`theme-block-${readerThemeIndex + 1}`);
                    themeToFocus.scrollIntoView({ behavior: "smooth" });
                }

                this.$_dispatchPlayerActionEvent("play", this.actionEventProps);
            }
        },
        getThemeIndexById(id) {
            return this.readerThemes.findIndex(item => item.id == id);
        }
    }
}
</script>
